module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/babel-runtime/core-js/object/assign.js
// module id = Rln+
// module chunks = 0